import bbox from '@turf/bbox'
import { polygon } from '@turf/helpers'

import { filterUnique2dArray } from '@/utils'

export const coordinatesFromFeatureCollection = featureCollection =>
  featureCollection.features[0].geometry.coordinates[0]

export const featureCollectionHasCoordinates = featureCollection =>
  featureCollection.features?.[0]?.geometry?.coordinates?.length > 0

export const polygonFeatureFromCoordinates = (coordinates, properties) => {
  if (coordinates.length < 4) {
    throw new Error('Insufficient amount of coordinates. Please provide at least 4')
  }
  // Ensure polgon ring https://datatracker.ietf.org/doc/html/rfc7946#section-3.1.6
  const polygonCoordinates =
    coordinates[0][0] === coordinates[coordinates.length - 1][0] &&
    coordinates[0][1] === coordinates[coordinates.length - 1][1]
      ? coordinates
      : [...coordinates, coordinates[0]]
  return polygon([polygonCoordinates], {
    bbox: bbox(polygon([polygonCoordinates])),
    ...properties,
  })
}

// works for every object with uuid and mb_feature_polygon
export const staticPolygonsFromObject = (type, { uuid, mb_feature_polygon }) => {
  if (!mb_feature_polygon || !mb_feature_polygon.length) return null

  return polygonFeatureFromCoordinates(coordinatesFromFeatureCollection(JSON.parse(mb_feature_polygon)), {
    id: uuid,
    type,
  })
}

export const uniqueCoordinatesFromFeatureCollection = featureCollection => {
  const coordinates = coordinatesFromFeatureCollection(featureCollection)
  return filterUnique2dArray(coordinates)
}
